const ALLOWED_DOMAINS = [
  'youtube.com',
  'youtube-nocookie.com',
  'youtu.be',
  'vimeo.com',
  'player.vimeo.com',
];

const InvalidEmbed = () => (
  <div className="aspect-w-16 aspect-h-9 mb-8 bg-muted flex items-center justify-center rounded">
    <p className="text-muted-foreground text-sm">Invalid or unsupported video embed</p>
  </div>
);

interface VideoEmbedProps {
  content: string;
}

const VideoEmbed = ({ content }: VideoEmbedProps) => {
  const srcMatch = content.match(/src=["']([^"']+)["']/);
  if (!srcMatch) return <InvalidEmbed />;

  let url: URL;
  try {
    url = new URL(srcMatch[1]);
  } catch {
    return <InvalidEmbed />;
  }

  if (url.protocol !== 'https:') return <InvalidEmbed />;

  const isAllowed = ALLOWED_DOMAINS.some(
    (d) => url.hostname === d || url.hostname.endsWith('.' + d)
  );
  if (!isAllowed) return <InvalidEmbed />;

  // Render a clean iframe with only the validated URL — no raw HTML injection.
  return (
    <div className="aspect-w-16 aspect-h-9 mb-8">
      <iframe
        src={url.toString()}
        title="Embedded video"
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        sandbox="allow-scripts allow-same-origin allow-presentation"
        className="w-full h-full border-0"
      />
    </div>
  );
};

export default VideoEmbed;
